import React, { Component } from 'react';
import { CardContent } from './Card';

export interface TabProps
{
	label: string
	content: JSX.Element
}

export interface TabsProps
{
	tabs: TabProps[]
	selectedTabIndex?: number
}

interface TabsState
{
	selectedIndex: number
}

export default class Tabs extends Component<TabsProps,TabsState>
{
	static defaultProps = {
		selectedTabIndex: 0
	};

	constructor(props: TabsProps)
	{
		super(props);
		// determine the selected tab index (assuming the first index is 0)
		const sti = (props.tabs[props.selectedTabIndex] !== undefined ? props.selectedTabIndex : 0);
		this.state = {
			selectedIndex: sti
		};
	}

	handleTabClicked(selectedIndex: number)
	{
		this.setState({
			selectedIndex: selectedIndex
		});
	};

	render()
	{
		return (
			<React.Fragment>
				<div className="ajb-grid ajb-tabs-nav">
					<div className="ajb-tabs-nav-wrapper">
						{this.props.tabs.map( (item, i) => {
							const tabButtonProps = {
								selected: (this.state.selectedIndex == i),
								label: item.label,
								index: i,
								handleClick: this.handleTabClicked.bind(this)
							};
							return (
								<React.Fragment key={i}>
									<TabButton {...tabButtonProps} />
									{(i < this.props.tabs.length-1) &&
									<span className="ajb-tab-nav-divider light-text">|</span>
									}
								</React.Fragment>
							);
						})}
					</div>
				</div>
				<div className="ajb-grid ajb-tabs-stage">
					<CardContent classnames="ajb-tabs-stage-content">
						{this.props.tabs[this.state.selectedIndex].content}
					</CardContent>
				</div>
			</React.Fragment>
		);
	}
}

/**
 * TabButton component
 * Used internally for the Tabs component as tab buttons to select which Tab content to display
 */
interface TabButtonProps
{
	selected: boolean
	label: string
	index: number
	handleClick: any
}
class TabButton extends Component<TabButtonProps>
{
	handleClick(e: Event)
	{
		e.preventDefault();
		this.props.handleClick(this.props.index);
	};

	render()
	{
		const className = `ajb-tab${this.props.selected ? ' ajb-tab-active':''}`;
		return (
			<span className={className}>
				<a onClick={this.handleClick.bind(this)} href="">{this.props.label}</a>
			</span>
		);
	}
}